import { AnyFieldApi } from "@tanstack/react-form";

export default function getFieldErrorState(field: AnyFieldApi) {
  const hasErrors = field.getMeta().errors.length > 0;
  const isDirty = field.getMeta().isDirty && !field.getMeta().isDefaultValue;
  const isValid = field.getMeta().isValid;
  const isBlurred = field.getMeta().isBlurred;
  const hasSubmissions = field.form.state.submissionAttempts > 0;

  return (isBlurred || hasSubmissions) && hasErrors && !isValid && isDirty;
}
